module.exports = __webpack_public_path__ + "img/Certificate_4.dbdfbe06.jpg";